module.exports = __webpack_public_path__ + "static/media/insta.ee59d043.png";